module.exports = "/static-assets/_next/static/images/pixel-grid-044b8eb3da04014ec546d482fa666159.gif";